// src/components/gestionEvento/formsAjustes/DatosLocacionForm.js

import React from 'react';
import PropTypes from 'prop-types'; // Importar PropTypes
import { Grid, TextField, Box, Typography } from '@mui/material';

const DatosLocacionForm = ({
  formData = {}, // Proveer default vacío
  errors = {},   // Proveer default vacío
  onChange,      // Recibe el handler específico (ej. handleChangeLocation)
  // Quitar isValidGoogleMapsEmbedLink de las props
}) => {

  // *** MOVER LA FUNCIÓN DE VALIDACIÓN AQUÍ ***
  const isValidGoogleMapsEmbedLink = (link) => {
    if (!link || typeof link !== 'string') return false; // Añadir chequeo de tipo
    // Expresión regular para validar enlaces de embebido de Google Maps
    // Ajustada para ser un poco más flexible (puede empezar con http o https)
    const regex = /^https?:\/\/www\.google\.com\/maps\/embed\?pb=.*$/;
    return regex.test(link);
  };
  // *** FIN FUNCIÓN MOVIDA ***

  const sectionSx = {
    '& .MuiOutlinedInput-root': { borderRadius: 2 },
  };

  return (
    <Grid container spacing={2} disableEqualOverflow sx={sectionSx}>
      {/* Lugar */}
      <Grid item xs={12} sm={6}>
        <TextField
          // required // Considera si la validación final se hace en el padre
          label="Nombre de la Instalación, Lugar o Sede"
          name="lugar"
          fullWidth
          value={formData.lugar ?? ''} // Usar ?? ''
          onChange={(e) => onChange(e.target.name, e.target.value)}
          error={Boolean(errors.lugar)}
          helperText={errors.lugar}
          variant="outlined"
        />
      </Grid>

      {/* Dirección */}
      <Grid item xs={12} sm={6}>
        <TextField
          label="Dirección"
          name="direccion"
          fullWidth
          value={formData.direccion ?? ''} // Usar ?? ''
          onChange={(e) => onChange(e.target.name, e.target.value)}
          error={Boolean(errors.direccion)}
          helperText={errors.direccion}
          variant="outlined"
        />
      </Grid>

      {/* Enlace Corto */}
      <Grid item xs={12} sm={6}>
        <TextField
          label="Enlace Corto de Google Maps"
          name="mapShortLink"
          fullWidth
          value={formData.mapShortLink ?? ''} // Usar ?? ''
          onChange={(e) => onChange(e.target.name, e.target.value)}
          placeholder="https://maps.app.goo.gl/..."
          error={Boolean(errors.mapShortLink)}
          helperText={errors.mapShortLink || 'Ejemplo: https://maps.app.goo.gl/...'}
          variant="outlined"
        />
      </Grid>

      {/* Enlace Embebido */}
      <Grid item xs={12} sm={6}>
        <TextField
          label="Enlace de Embebido de Google Maps"
          name="mapEmbedLink"
          fullWidth
          value={formData.mapEmbedLink ?? ''} // Usar ?? ''
          onChange={(e) => onChange(e.target.name, e.target.value)}
          placeholder="https://www.google.com/maps/embed?pb=..."
          error={Boolean(errors.mapEmbedLink)}
          helperText={errors.mapEmbedLink || 'Enlace de iframe de Google Maps.'}
          variant="outlined"
        />
      </Grid>

      {/* Previsualización (Usa la función local ahora) */}
      <Grid item xs={12}>
        {formData.mapEmbedLink ? ( // Mostrar siempre que haya algo en el campo
          isValidGoogleMapsEmbedLink(formData.mapEmbedLink) ? ( // Validar si es correcto
            <Box sx={{ width: '100%', height: 300, border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden' }}>
              <iframe
                src={formData.mapEmbedLink}
                width="100%" height="100%" style={{ border: 0 }}
                allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"
                title="Mapa de la Competencia">
              </iframe>
            </Box>
          ) : ( // Mostrar error si no es válido
            <Typography color="error" variant="caption">
              El enlace de embebido no parece válido. Revisa la URL completa que copiaste de Google Maps.
            </Typography>
          )
        ) : null /* No mostrar nada si el campo está vacío */}
      </Grid>
    </Grid>
  );
};

// Añadir PropTypes para asegurar que formData y onChange se pasen
DatosLocacionForm.propTypes = {
    formData: PropTypes.shape({
        lugar: PropTypes.string,
        direccion: PropTypes.string,
        mapShortLink: PropTypes.string,
        mapEmbedLink: PropTypes.string,
    }),
    errors: PropTypes.object,
    onChange: PropTypes.func.isRequired,
};


export default DatosLocacionForm;
